import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
    state:{
        city:{
            "city": "深圳",
            "cityCode": "sz",
            "citySite": "1001001002001000000"
        },
        cityItems:[],
        isPC:false,
        domainIndex:0,
        filterStr:[],
    },
    mutations:{
        updateCity(state,city){
            state.city = city
        },
        updateCityItems(state,data){
            state.cityItems = data
        },
        updateIsPC(state,bool){
            state.isPC = bool
        },
        updateDomainIndex(state,data){
            state.domainIndex = data
        },
        updateFilterStr(state,data){
            state.filterStr = data
        },
    }
})

export default store





// WEBPACK FOOTER //
// ./src/store/index.js